import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { FlyFreelyConstants } from '@flyfreely-portal-ui/flyfreely';
import { AvailableReportDto } from '@flyfreely-portal-ui/flyfreely';

@Injectable({
    providedIn: 'root'
})
export class AuthorityReportService {
    private baseUrl: string;

    constructor(constants: FlyFreelyConstants, private http: HttpClient) {
        this.baseUrl = constants.SITE_URL;
    }

    findAvailableTemplates(
        reportEventIdentifier: string,
        authorityTypeId: number,
        managingOrganisationId: number
    ) {
        return this.http.get<AvailableReportDto[]>(
            `${this.baseUrl}/reportsapi/authority`,
            {
                params: new HttpParams()
                    .set('reportEventIdentifier', reportEventIdentifier)
                    .set(
                        'authorityTypeId',
                        authorityTypeId ? authorityTypeId.toString() : null
                    )
                    .set(
                        'managingOrganisationId',
                        managingOrganisationId
                            ? managingOrganisationId.toString()
                            : null
                    )
            }
        );
    }

    getHtmlReportUrl(
        reportTemplateId: number,
        authorityId: number,
        managingOrganisationId: number
    ) {
        const params = new HttpParams()
            .set('managingOrganisationId', managingOrganisationId.toString())
            .toString();

        return `${this.baseUrl}/reportsapi/authority/${authorityId}/render/${reportTemplateId}?${params}`;
    }

    getPdfReportUrl(
        reportTemplateId: number,
        authorityId: number,
        managingOrganisationId: number
    ) {
        const params = new HttpParams()
            .set(
                'managingOrganisationId',
                managingOrganisationId
                    ? managingOrganisationId.toString()
                    : null
            )
            .set('format', 'pdf')
            .toString();

        return `${this.baseUrl}/reportsapi/authority/${authorityId}/render/${reportTemplateId}?${params}`;
    }
}
